// userSelectors.js

export const selectDepartment = (state) => state.login.department;
export const selectLoading = (state) => state.login.loading;
export const selectError = (state) => state.login.error;
export const selectRedirectUrl = (state) => state.login.redirectUrl;

